import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0B0E14] text-white">
      <div className="max-w-md text-center space-y-4" data-testid="payment-cancel-page">
        <div className="font-display font-black text-3xl">Payment cancelled</div>
        <div className="text-sm text-[#94A3B8]">No charge was made. You can upgrade anytime.</div>
        <Button onClick={() => navigate("/studio")} className="bg-[#00F0FF] text-black hover:bg-[#33F3FF] font-black uppercase tracking-widest">Back to Studio</Button>
      </div>
    </div>
  );
}
